import React from 'react'
import NextImage from 'next/image'
import styles from './styles.module.scss'
import { Button } from '@components/ui/Button'
import SectionHeader from '@components/ui/SectionHeader'
import { useFitFinderToggle } from '@components/FitFinder/hooks/useFitFinderToggle'
import { analytics } from '@helpers/analytics'
import { getIsFirstTimeUser } from '@helpers/session/user'
import { useFit } from '@helpers/hooks/useFit'

const FitProposition = () => {
  const { savedFit } = useFit()
  const { openFitFinder } = useFitFinderToggle()

  const handleFitButton = () => {
    openFitFinder()
    const firstTimeUser = getIsFirstTimeUser()
    analytics('Click', {
      category: 'Landing Page',
      label: 'Fit Module',
      action: 'Find My Fit',
      type: firstTimeUser ? 'new' : 'existing'
    })
  }

  return (
    <div className={styles.FitProposition__wrapper}>
      <div className={styles.FitProposition__container}>
        <div className={styles.FitProposition__description}>
          <SectionHeader
            title="Flawless Fit Promise"
            variant="left_aligned"
            className={styles.FitProposition__description__header}
          />
          <div>
            <p>
              Style is nothing without fit. No man should settle for average.
            </p>
            <p>
              So we cut menswear in hundreds of combinations, as standard. For a
              flawlessly fine-tuned fit, straight out the box. It’s like
              tailoring, without the tailor.
            </p>
          </div>
          <Button
            variant="secondary"
            fullWidth="never"
            onClick={handleFitButton}
          >
            {savedFit ? 'My Fit' : 'Find your Fit'}
          </Button>
        </div>
        <div className={styles.FitProposition__imageContainer}>
          <NextImage
            src="/static/images/enduros/fit_proposition_bottoms.jpg"
            alt="Shop Collection"
            width="636"
            height="872"
          />
          <NextImage
            src="/static/images/enduros/fit_proposition_tops.jpg"
            alt="Shop Collection"
            width="636"
            height="872"
          />
        </div>
      </div>
    </div>
  )
}

export default FitProposition
